import React from 'react';
import SparkleIcon from './SparkleIcon';
import style from './RecommendBox.module.css';

const RecommendBox = ({ title = 'AI 식단 추천', description, onClick }) => {
    return (
        <div className={style.WrapBox}>
            <button type="button" className={style.box} onClick={onClick}>
                <div className={style.inner}>
                    <div className={style.head}>
                        <span className={style.title}>
                            <SparkleIcon size={22} />
                            {title}
                        </span>
                        <span className={style.cta}>챗봇 ›</span>
                    </div>
                    <p className={style.desc}>
                        {description ?? (
                            <>
                                어쩌구저쩌구 이러쿵저러쿵 해서<br />
                                오늘의 메뉴는 <b>○○○○○○○</b>를 추천합니다.
                            </>
                        )}
                    </p>
                </div>
            </button>
        </div>
    );
};

export default RecommendBox;